import { render, staticRenderFns } from "./ReservationsPage.vue?vue&type=template&id=a89b6eec&"
import script from "./ReservationsPage.vue?vue&type=script&lang=js&"
export * from "./ReservationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports